export class SearchParamBuilder {
  private params: URLSearchParams;

  constructor(initial?: URLSearchParams | Record<string, string>) {
    this.params = initial instanceof URLSearchParams ? new URLSearchParams(initial) : new URLSearchParams(initial);
  }

  /**
   * Sets a key if value is not null/undefined and not an empty string.
   */
  setIfDefined(key: string, value: string | number | boolean | null | undefined): this {
    if (value === null || value === undefined) {
      return this;
    }

    const str = String(value).trim();
    if (str.length === 0) {
      return this;
    }

    this.params.set(key, str);
    return this;
  }

  /**
   * Appends multiple values as repeated query parameters.
   */
  appendArrayParam(key: string, values?: readonly (string | null | undefined)[]): this {
    if (!values?.length) {
      return this;
    }

    values
      .filter((v): v is string => typeof v === "string" && v.trim().length > 0)
      .forEach((v) => this.params.append(key, v));

    return this;
  }

  /**
   * Gets the final URLSearchParams object.
   */
  build(): URLSearchParams {
    return this.params;
  }

  /**
   * Converts params to string.
   */
  toString(): string {
    return this.params.toString();
  }
}
